import React, { useEffect, useRef } from 'react';
import { render } from 'react-dom';
import styles from './ComparisonChartRow.module.scss';
import cx from 'classnames';
import { Icon, Text } from '../index';
import { ICONS_PATH } from '../../lib/constants';

const SELECTORS = {
    CONTAINER: 'fs-comparison-chart__container',
};

const ComparisonChartRowMobile = (props) => {
    const rowRef = useRef();
    const { rowTitle, helpTipText } = props;
    const actualColumns = Object.keys(props).filter((k) => k.includes('columnContent')).length;
    const cardContents = [];
    const iconName = 'information-circle-grey-filled.svg';

    for (let cardIndex = 0; cardIndex < actualColumns; cardIndex++) {
        const rowText = props[`columnContent${cardIndex + 1}`];
        const isRowHelpTipTextEmpty =
            !helpTipText || !helpTipText.length || helpTipText.length === 0;
        const isHelpTipTextEmpty =
            !props[`helpTipText${cardIndex + 1}`] ||
            !props[`helpTipText${cardIndex + 1}`].length ||
            props[`helpTipText${cardIndex + 1}`].length === 0;
        const helpTipTextColumn = !isHelpTipTextEmpty ? props[`helpTipText${cardIndex + 1}`] : null;
        const helpTipId = !isHelpTipTextEmpty
            ? `${cardIndex}-text-helptip-${helpTipTextColumn}`
            : null;
        const helpTipRowId = !isRowHelpTipTextEmpty
            ? `${cardIndex}-text-helptip-${helpTipText}`
            : null;

        const cardRow = (
            <div className={cx(styles['card-row'], `card-${cardIndex + 1}`)} key={cardIndex}>
                <div className={cx(styles.wrapper)}>
                    <Text size="small" content={rowTitle} className={styles['column__title']} />
                    {helpTipText && (
                        <div
                            role="tooltip"
                            className={cx(
                                styles['helptip__container'],
                                styles['helptip__container--mobile']
                            )}
                        >
                            <div
                                tabIndex={0}
                                aria-label="info:"
                                className={cx(styles['helptip__icon'])}
                            >
                                <Icon url={ICONS_PATH + iconName} size={'xx-small'} />
                            </div>
                            <span
                                className={cx(
                                    styles['helptip__text-container'],
                                    styles['helptip__text-container--right']
                                )}
                            >
                                <p
                                    tabIndex={0}
                                    id={helpTipRowId}
                                    className={cx(styles['helptip__text-content'])}
                                >
                                    {helpTipText}
                                </p>
                            </span>
                        </div>
                    )}
                </div>
                <div className={cx(styles.wrapper)}>
                    <Text size="large" content={rowText} className={styles['column__content']} />
                    {helpTipTextColumn && (
                        <div
                            role="tooltip"
                            className={cx(
                                styles['helptip__container'],
                                styles['helptip__container--mobile']
                            )}
                        >
                            <div
                                tabIndex={0}
                                aria-label="info:"
                                className={cx(styles['helptip__icon'])}
                            >
                                <Icon url={ICONS_PATH + iconName} size={'xx-small'} />
                            </div>
                            <span
                                className={cx(
                                    styles['helptip__text-container'],
                                    styles['helptip__text-container--right']
                                )}
                            >
                                <p
                                    tabIndex={0}
                                    id={helpTipId}
                                    className={cx(styles['helptip__text-content'])}
                                >
                                    {helpTipTextColumn}
                                </p>
                            </span>
                        </div>
                    )}
                </div>
            </div>
        );
        cardContents.push({
            id: `card-${cardIndex + 1}`,
            cardRow,
        });
    }

    useEffect(() => {
        const rowElement = rowRef.current;
        if (rowElement) {
            const container = rowElement.closest(`.${SELECTORS.CONTAINER}`);
            if (container) {
                cardContents.forEach((content) => {
                    const cardBody = container.querySelector(`.card-body.${content.id}`);
                    const cardBodyRow = document.createElement('div');
                    cardBody.appendChild(cardBodyRow);
                    render(content.cardRow, cardBodyRow);
                });
            }
        }
    });

    return <div ref={rowRef}></div>;
};

export default ComparisonChartRowMobile;
